import {EnrollmentApplication} from 'Enrollment/models/EnrollmentApplication';
import {EnrollmentFileStatusType} from 'Enrollment/models/EnrollmentFileStatusType';
import React, {useState} from 'react';
import EnrollmentFileProcessingStep from './EnrollmentFileProcessingStep';
import InProgressRecords from './InProgressRecords';
import SuccessfulRecords from './SuccessfulRecords';
import UnsuccessfulRecords from './UnsuccessfulRecords';
import CancelledRecords from './CancelledRecords';
import {Button, MobileStepper, useMediaQuery} from '@material-ui/core';
import {theme} from 'Core/components/WithTheme';
import {ExternalEnrollmentFileUploadSteps} from 'Shared/constants/ExternalEnrollmentFileUploadSteps';
import {KeyboardArrowLeft, KeyboardArrowRight} from '@material-ui/icons';
import './MobileStatusTracker.sass';
import ReturnedlRecords from './ReturnedRecords';
type StepEnum = {
  id: number;
  value: string;
};
type HorizontalStatusTrackerProps = {
  enrollmentFile: EnrollmentApplication;
  steps: StepEnum[];
  currentStep?: number;
};

const HorizontalStatusTracker = ({enrollmentFile, steps, currentStep}: HorizontalStatusTrackerProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeStep, setActiveStep] = useState(currentStep!);

  const isProcessingInProgress = enrollmentFile.fileStatus!.id === EnrollmentFileStatusType.PROCESSING;
  const hasProcessingCompleted = enrollmentFile.fileStatus!.id === EnrollmentFileStatusType.COMPLETED;
  const isCanceledReceived =
    enrollmentFile.fileStatus!.id === EnrollmentFileStatusType.CANCELED &&
    enrollmentFile.fileStatusIdBeforeCanceled! === EnrollmentFileStatusType.RECEIVED;
  const isCanceledProcessing =
    enrollmentFile.fileStatus!.id === EnrollmentFileStatusType.CANCELED &&
    enrollmentFile.fileStatusIdBeforeCanceled! === EnrollmentFileStatusType.PROCESSING;

    const isReturnedReceived =
    enrollmentFile.fileStatus!.id === EnrollmentFileStatusType.Returned &&
    enrollmentFile.fileStatusIdBeforeCanceled! === EnrollmentFileStatusType.RECEIVED;
    const isReturnedProcessing =
    enrollmentFile.fileStatus!.id === EnrollmentFileStatusType.Returned &&
    enrollmentFile.fileStatusIdBeforeCanceled! === EnrollmentFileStatusType.PROCESSING;

  const hasError = enrollmentFile.invalidRecordCount! > 0;
  const inProgressStepStatus = isProcessingInProgress
    ? 'current'
    : hasProcessingCompleted
    ? 'completed'
    : isCanceledProcessing
    ? 'canceled'
    : isReturnedProcessing
    ? 'error'
    : 'inactive';

  const fileUploadStepStatusDetail = (
    <EnrollmentFileProcessingStep
      stepName="File Uploaded"
      titleClassName={enrollmentFile.validRecordCount! === 0 ? "error" : enrollmentFile.validRecordCount! > 0  && enrollmentFile.invalidRecordCount! > 0 ? "warning" :"completed"}
      statusIcon={<i className={enrollmentFile.validRecordCount! === 0 ? "fas fa-times-circle status__unsuccessful" : enrollmentFile.validRecordCount! > 0  && enrollmentFile.invalidRecordCount! > 0 ? "fas fa-exclamation-triangle status__warning" : "fas fa-check-circle status__successful"} />}
    >
      {enrollmentFile.validRecordCount! > 0 && <SuccessfulRecords count={enrollmentFile.validRecordCount!} />}
      {enrollmentFile.invalidRecordCount! > 0 && <UnsuccessfulRecords count={enrollmentFile.invalidRecordCount!} />}
    </EnrollmentFileProcessingStep>
  );

  
  const receivedStepStatusDetail = (
    <EnrollmentFileProcessingStep
      stepName="Received"
      titleClassName={
        isCanceledReceived ? 'canceled' : hasError || enrollmentFile.rowCount! === 0 || isReturnedReceived ? 'error' : 'completed'
      }
      statusIcon={
        <i
          className={`fas ${
              isCanceledReceived ? 'fa-times-circle status__canceled'
              : hasError || enrollmentFile.rowCount! === 0 || isReturnedReceived
              ? 'fa-times-circle status__unsuccessful'
              : 'fa-check-circle status__successful'
          }`}
        />
      }
    >
      {!isCanceledReceived && enrollmentFile.invalidRecordCount! === 0 && enrollmentFile.rowCount! !== 0 && !isReturnedReceived && (
        <SuccessfulRecords count={enrollmentFile.rowCount!} />
      )}
      {!isCanceledReceived && enrollmentFile.invalidRecordCount! > 0 && (
        <UnsuccessfulRecords count={enrollmentFile.rowCount!} />
      )}
      {isCanceledReceived && enrollmentFile.rowCount! !== 0 && <CancelledRecords count={enrollmentFile.rowCount!} />}
      {isReturnedReceived && (
        <ReturnedlRecords count={enrollmentFile.rowCount!} />
      )}
    </EnrollmentFileProcessingStep>
  );

  const processingStepStatusDetail = (
    <EnrollmentFileProcessingStep
      stepName="Processed"
      titleClassName={inProgressStepStatus}
      statusIcon={
        isProcessingInProgress ? (
          <i className="far fa-circle status__processing" />
        ) : isCanceledProcessing ? (
          <i className="fas fa-times-circle status__canceled" />
        )  : isReturnedProcessing ? (
          <i className="fas fa-times-circle status__unsuccessful" />
        )
        
        : (
          <i
            className={
              hasProcessingCompleted ? 'fas fa-check-circle status__successful' : 'far fa-circle status__inactive'
            }
          />
        )
      }
    >
      {hasProcessingCompleted && <SuccessfulRecords count={enrollmentFile.validRecordCount!} />}
      {(isCanceledProcessing )&& <CancelledRecords count={enrollmentFile.validRecordCount!} />}
      {isProcessingInProgress && <InProgressRecords count={enrollmentFile.validRecordCount!} />}
      {isReturnedProcessing && <ReturnedlRecords count={enrollmentFile.validRecordCount!} />}
    </EnrollmentFileProcessingStep>
  );

  const processingCompleteStepStatusDetail = (
    <EnrollmentFileProcessingStep
      stepName="Confirmed"
      titleClassName={hasProcessingCompleted ? 'completed' : 'inactive'}
      statusIcon={
        <i
          className={
            hasProcessingCompleted ? 'fas fa-check-circle status__successful' : 'far fa-circle  status__inactive'
          }
        />
      }
    >
      {hasProcessingCompleted && (
        <>
          {' '}
          <SuccessfulRecords count={enrollmentFile.validRecordCount!} />
        </>
      )}
    </EnrollmentFileProcessingStep>
  );
  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };
  const getCurrentEnrollmentFileProcessingStep = (activeStep: number) => {
    switch (activeStep) {
      case ExternalEnrollmentFileUploadSteps.FileUpload:
        return fileUploadStepStatusDetail;
      case ExternalEnrollmentFileUploadSteps.Received:
        return receivedStepStatusDetail;
      case ExternalEnrollmentFileUploadSteps.Processing:
        return processingStepStatusDetail;
      case ExternalEnrollmentFileUploadSteps.ProcessingComplete:
        return processingCompleteStepStatusDetail;
    }
  };
  const maxSteps = steps.length;
  return isMobile ? (
    <div className="mobile-status-tracker">
      {getCurrentEnrollmentFileProcessingStep(activeStep)}
      <div>
        <MobileStepper
          steps={maxSteps}
          position="static"
          variant="text"
          activeStep={activeStep}
          nextButton={
            <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
              {activeStep === maxSteps - 1 ? steps[activeStep].value : steps[activeStep + 1].value}
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
              {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
              {activeStep === 0 ? steps[activeStep].value : steps[activeStep - 1].value}
            </Button>
          }
        />
      </div>
    </div>
  ) : (
    <div className="horizontal-status-tracker" id="horizontal-status-tracker">
      {fileUploadStepStatusDetail}
      <span className="horizontal-status-tracker__divider completed" />
      {receivedStepStatusDetail}
      <span
        className={`horizontal-status-tracker__divider ${
          enrollmentFile.rowCount! === 0 ? '' : !hasError && !isCanceledReceived ? 'completed' : ''
        }`}
      />
      {processingStepStatusDetail}
      <span className={`horizontal-status-tracker__divider ${hasProcessingCompleted ? 'completed' : ''}`} />
      {processingCompleteStepStatusDetail}
    </div>
  );
};

export default HorizontalStatusTracker;
